import { useContext } from "react";
import { CursorContext } from "../context/CursorContext";

export default function Footer() {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <div
      className="fixed bottom-0 left-0 w-full text-center p-4 backdrop-blur-md bg-beige/30 dark:bg-black/30"
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
    >
      Copyright ©️{new Date().getFullYear()} All rights reserved | This website
      is made by GuruLeo🍃
    </div>
  );
}
